// extracted by mini-css-extract-plugin
export var body = "_lg-5";
export var closeButton = "_lg-f";
export var container = "_lg-1";
export var content = "_lg-2";
export var cta = "_lg-c";
export var ctaLabel = "_lg-b";
export var eyebrow = "_lg-3";
export var howTo = "_lg-6";
export var image = "_lg-e";
export var modal = "_lg-0";
export var socialButton = "_lg-d";
export var stepCard = "_lg-8";
export var stepLabel = "_lg-a";
export var stepNumber = "_lg-9";
export var steps = "_lg-7";
export var title = "_lg-4";